import { render, staticRenderFns } from "./CourtagenPage.vue?vue&type=template&id=3694eb9f&"
import script from "./CourtagenPage.vue?vue&type=script&lang=js&"
export * from "./CourtagenPage.vue?vue&type=script&lang=js&"
import style0 from "./CourtagenPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDataTable,VDivider,VIcon,VSelect})
